import { render, staticRenderFns } from "./TendenciaLive.vue?vue&type=template&id=c0dd9e7a&scoped=true&"
import script from "./TendenciaLive.vue?vue&type=script&lang=js&"
export * from "./TendenciaLive.vue?vue&type=script&lang=js&"
import style0 from "./TendenciaLive.vue?vue&type=style&index=0&id=c0dd9e7a&scoped=true&lang=css&"
import style1 from "./TendenciaLive.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0dd9e7a",
  null
  
)

export default component.exports